export interface GenreEntry {
  name: string;
  icon: string;
  description: string;
}

export const genres: GenreEntry[] = [
  { name: "动作", icon: "ri-flashlight-line", description: "追车、爆破与不肯低头的硬汉" },
  { name: "科幻", icon: "ri-rocket-2-line", description: "霓虹、机械与对未来的全部想象" },
  { name: "爱情", icon: "ri-heart-3-line", description: "在时代噪音里认真谈一场恋爱" },
  { name: "喜剧", icon: "ri-emotion-happy-line", description: "用笑声拆解青春与成人世界" },
  { name: "剧情", icon: "ri-film-line", description: "关于人如何与自己和解" },
  { name: "恐怖", icon: "ri-ghost-2-line", description: "走廊尽头那些说不清的东西" },
  { name: "战争", icon: "ri-shield-star-line", description: "炮火之下的人性考题" },
  { name: "冒险", icon: "ri-compass-3-line", description: "出发，去一个没有地图的地方" },
];